import { useAuth0 } from "@auth0/auth0-react";
import React from "react"

import LoginButton from "./login";
import LogoutButton from "./logout";

const AuthButton = () => {
    const { user, isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();

  let authButton;

  if (isLoading) {
    return <div>Loading ...</div>;
  } else {
    if (isAuthenticated) {
      
      console.log(getAccessTokenSilently());

        console.log("Authenticated" + user)
        authButton = <LogoutButton />;
      } else {
        console.log("Not Authenticated")
        authButton = <LoginButton />;
      }
  }

  return (
   <div>{authButton}</div>
  )
};

export default AuthButton;